import React from 'react';
import { isValidNumber, validatePhoneNumberLength } from 'libphonenumber-js';
import { useDispatch, useSelector } from 'react-redux';
import { createSuperUserAction } from '../redux/actions/client-actions';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { makeStyles } from '@material-ui/core/styles';
import { TextField, Button, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  },
  sectionHeading: {
    margin: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtons: {
    marginTop: theme.spacing(2)
  },
  errorText: {
    color: '#f44336',
    textAlign: 'center',
    display: 'block',
    margin: theme.spacing(3)
  }
}));

function CreateSuperUserForm(props) {
  const classes = useStyles();

  const { error, loading } = useSelector((state) => state.loading);

  const { values, errors, touched, handleSubmit, handleChange, handleBlur, handleClose } = props;

  /**
   * @param {string} name
   */
  const formikProps = (name, initialValue = '') => ({
    name: name,
    value: typeof values[name] !== 'undefined' ? values[name] : initialValue,
    onChange: handleChange,
    onBlur: handleBlur,
    error: touched[name] && Boolean(errors[name]),
    helperText: touched[name] ? errors[name] : ''
  });

  return (
    <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
      <TextField
        {...formikProps('firstname')}
        id="outlined-full-width"
        label="First Name"
        type="text"
        variant="outlined"
        fullWidth={true}
      />

      <TextField
        {...formikProps('lastname')}
        id="outlined-full-width"
        label="Last Name"
        type="text"
        variant="outlined"
        fullWidth={true}
      />

      <TextField
        {...formikProps('email')}
        id="outlined-full-width"
        label="Email"
        type="text"
        variant="outlined"
        fullWidth={true}
      />

      <TextField
        {...formikProps('mobile_no')}
        id="outlined-full-width"
        label="Phone no."
        type="text"
        variant="outlined"
        fullWidth={true}
      />

      <div className={classes.formButtons}>
        {!loading && (
          <>
            <Button
              className={classes.margin}
              type="submit"
              variant="contained"
              size="large"
              color="primary"
              fullWidth={true}
            >
              Create Super User
            </Button>

            <Button
              className={classes.margin}
              variant="outlined"
              size="large"
              color="secondary"
              fullWidth={true}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </>
        )}

        {loading && (
          <Button
            className={classes.margin}
            variant="contained"
            size="large"
            color="primary"
            fullWidth={true}
          >
            <CircularProgress color="inherit" size={26} />
          </Button>
        )}

        {error && (
          <div>
            <span className={classes.errorText}>{error.message}</span>
          </div>
        )}
      </div>
    </form>
  );
}

const validationSchema = Yup.object({
  firstname: Yup.string('Enter first name').required('First name is required'),
  lastname: Yup.string('Enter last name').required('Last name is required'),
  email: Yup.string('Enter email').email('Enter a valid email').required('Email is required'),
  mobile_no: Yup.string('Enter user phone no.')
    .test('Phone Test', 'Enter a valid phone no., with iso code.', (value) => {
      try {
        return isValidNumber(value) && validatePhoneNumberLength(value) === undefined;
      } catch (err) {
        return true;
      }
    })
    .required('Phone no. is required')
});

export function CreateSuperUserFormValidation({ client, handleClose }) {
  const dispatch = useDispatch();

  const values = { firstname: '', lastname: '', email: '', mobile_no: '' };

  const submit = (data) => {
    dispatch(
      createSuperUserAction(client.id, data.firstname, data.lastname, data.email, data.mobile_no)
    );
  };

  return (
    <Formik initialValues={values} validationSchema={validationSchema} onSubmit={submit}>
      {(props) => <CreateSuperUserForm {...props} handleClose={handleClose} />}
    </Formik>
  );
}
